module.exports = __webpack_public_path__ + "img/synthwave.fa9f14f3.jpg";